import { omit } from "lodash";

import client from "../client";
import { patchUserInformationConfig } from "./patchUserInformationConfig";

const patchUserInformation = async (data: any) =>
  await client({
    ...patchUserInformationConfig(data.authorization),
    data: omit(data, "authorization"),
  });

export default { patchUserInformation };
